import React from 'react'

const Contact = () => {
    return (
        <div>
            Coming Soon
        </div>
    );
};

export default Contact;